import { Formik, Field, Form } from 'formik'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useState, useCallback, useEffect } from 'react'
import { event } from '@bww/beke-lib/gtag'

import styles from './ContactForm.module.scss'

export default function ContactForm() {
  const [recaptchaToken, setRecaptchaToken] = useState(null)
  const { executeRecaptcha } = useGoogleReCaptcha()

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) return
    const token = await executeRecaptcha('contact')
    setRecaptchaToken(token)
  }, [executeRecaptcha])

  useEffect(() => {
    handleReCaptchaVerify()
    // get new token every 60 seconds
    const interval = setInterval(handleReCaptchaVerify, 60000)
    return () => clearInterval(interval)
  }, [handleReCaptchaVerify])

  return (
    <Formik
      initialValues={{ name: '', email: '', phone: '', enquiry: '' }}
      // initialValues={{
      //   name: 'Lloyd',
      //   email: 'lloydh@bluewaterweb.co.uk',
      //   phone: '01202 404222',
      //   enquiry: 'Test',
      // }}
      onSubmit={async (values, actions) => {
        try {
          if (!recaptchaToken) throw Error('Unable to verify submission')
          const bodyData = {
            ...values,
            recaptchaToken,
          }
          const body = JSON.stringify(bodyData)
          const res = await fetch('/api/submit', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body,
          }).then((response) => response.json())
          if (res?.success === true) {
            actions.resetForm({ status: { success: true } })
            if (res?.credit === true) {
              event('form_submit')
            }
          } else {
            actions.setStatus({ success: res?.success === true })
          }
        } catch (err) {}
      }}
    >
      {({ errors, touched, isSubmitting, status }) => (
        <Form>
          <StatusMessage status={status} />
          {status?.success !== true && (
            <div className={styles.fieldsContainer}>
              <div className={styles.field}>
                <label htmlFor="name">Name</label>
                <Field
                  type="text"
                  id="name"
                  name="name"
                  autoComplete="name"
                  required
                />
              </div>
              <div className={styles.field}>
                <label htmlFor="email">Email</label>
                <Field
                  type="text"
                  id="email"
                  name="email"
                  autoComplete="email"
                  required
                />
              </div>
              <div className={styles.field}>
                <label htmlFor="phone">Phone</label>
                <Field
                  type="tel"
                  id="phone"
                  name="phone"
                  autoComplete="tel-national"
                  required
                />
              </div>
              <div className={styles.field}>
                <label htmlFor="enquiry">Enquiry</label>
                <Field
                  as="textarea"
                  id="enquiry"
                  name="enquiry"
                  rows="5"
                  required
                />
              </div>

              <div className={styles.formControls}>
                <button
                  className="button button--accent"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Submit
                </button>
                <button type="reset" disabled={!touched}>
                  Clear form
                </button>
                <div className={styles.privacyNotice}>
                  <strong>No spam and we won't share your data.</strong>
                  <br />
                  <small>
                    See our <a href="/privacy-policy.pdf">Privacy Policy</a> |{' '}
                    Protected by reCAPTCHA
                    <br />
                    Google{' '}
                    <a href="https://policies.google.com/privacy">
                      Privacy Policy
                    </a>{' '}
                    &amp;{' '}
                    <a href="https://policies.google.com/terms">
                      Terms of Service
                    </a>{' '}
                    apply.
                  </small>
                </div>
              </div>
            </div>
          )}
        </Form>
      )}
    </Formik>
  )
}

const StatusMessage = ({ status }) => {
  if (status === undefined) return null
  return (
    <div className={styles.statusContainer}>
      {status?.success && (
        <>
          <div className="h2">Success</div>
          <p>Thank you, your enquiry has been sent.</p>
        </>
      )}
    </div>
  )
}
